import { useEffect } from 'react';
import PropTypes from 'prop-types';
import { withCoreComponent } from 'core/hocs';
import { CioFcmTracker as CioFcmTrackerCore } from 'core/components';
import {
  checkNotificationPermission,
  initializeFirebaseMessaging,
  isUserIdentifiedInCio,
  handleCioFcmInfo,
} from 'helpers/cio-fcm';

const CioFcmTrackerUI = ({ userData, isUserLoggedIn, setCioFcmInfo }) => {
  useEffect(() => {
    if (isUserLoggedIn) {
      const isIdentifiedInCio = isUserIdentifiedInCio();

      if (isIdentifiedInCio) {
        const onPermissionGranted = () => {
          initializeFirebaseMessaging({
            partyId: userData.partyId,
            setCioFcmInfo,
            onTokenReceived: handleCioFcmInfo,
          });
        };

        const onPermissionDenied = () => {
          console.log('permission denied');
        };

        checkNotificationPermission({
          onPermissionGranted,
          onPermissionDenied
        });
      }
    }
  }, [isUserLoggedIn]);

  return null;
};

CioFcmTrackerUI.propTypes = {
  userData: PropTypes.shape().isRequired,
  isUserLoggedIn: PropTypes.bool.isRequired,
  setCioFcmInfo: PropTypes.func.isRequired,
};

export const CioFcmTracker = withCoreComponent(CioFcmTrackerCore, CioFcmTrackerUI);
